import { Model } from '../model'

export type ThermostatCostCategoryControls = {
  id: number
  cool_setpoint_delta: number
  min_cost_cents: number
  max_cost_cents: number
} & Model

export type CostCategoryDisplay = {
  id: number
  minValue: number
  maxValue: number
  type: 'high' | 'medium' | 'low' | 'negative'
  initValue: number
}

export const costCategoryLabelTypes = <const>[
  'negative',
  'low',
  'medium',
  'high',
]
export type CostCategoryLabel = (typeof costCategoryLabelTypes)[number]
